import { Dash } from '@/ui/atoms/dash/Dash'
import { Tooltip, TooltipContentShort, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import Image from 'next/image'

interface CuratorIconProps {
  logo?: string | null
  name?: string | null
}

export function CuratorIcon({ logo, name }: CuratorIconProps) {
  const displayName = name || 'Curator'

  if (!logo) return <Dash />

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex h-6 w-6 cursor-pointer items-center justify-center overflow-hidden transition-transform hover:scale-110">
          <Image src={logo} alt={displayName} width={24} height={24} className="h-6 w-6 object-cover" />
        </div>
      </TooltipTrigger>
      <TooltipContentShort>{displayName}</TooltipContentShort>
    </Tooltip>
  )
}
